// removed by extract-text-webpack-plugin
module.exports = {"links":"styles-module__links___1Yqx5","pagination":"styles-module__pagination___1cR36"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/PaginationLinks/styles.module.css
// module id = 191
// module chunks = 0